import Gallery2025_1 from './Gallery2025_1.png'
import Gallery2025_2 from './Gallery2025_2.png'
import Gallery2025_3 from './Gallery2025_3.png'
import Gallery2025_4 from './Gallery2025_4.png'
import Gallery2024_1 from './Gallery2024_1.png'
import Gallery2024_2 from './Gallery2024_2.png'
import Gallery2024_3 from './Gallery2024_3.jpg'
import Gallery2024_4 from './Gallery2024_4.jpg'
import Gallery2023_1 from './Gallery2023_1.jpg'
import Gallery2023_2 from './Gallery2023_2.png'
import Gallery2023_3 from './Gallery2023_3.png'
import Gallery2023_4 from './Gallery2023_4.png'
import Gallery2023_CoverImage from './Gallery2023_CoverImage.png'
import Gallery2024_CoverImage from './Gallery2024_CoverImage.png'
import Gallery2025_CoverImage from './Gallery2025_CoverImage.png'
import Gallery_HowDifferent_1 from './Gallery_HowDifferent_1.png'
import Gallery_HowDifferent_2 from './Gallery_HowDifferent_2.png'
import TakeWaysForChildrenWithContent from './TakeWaysForChildrenImage.png'
import WhatWeDoBgImg from './WhatWeDoBgImg.png'
import TakeWaysForChildren from './TakeWaysForChildren.png'
import HeroBgImage from './HeroImage.png'
import BalloonImage from './BaloonImage.png'
import WhatWeDoImageWithConent from './WhatWeDoImageWithConent.png'

export const SummerCampImages = {
    Gallery2025_1,
    Gallery2025_2,
    Gallery2025_3,
    Gallery2025_4,
    Gallery2024_1,
    Gallery2024_2,
    Gallery2024_3,
    Gallery2024_4,
    Gallery2023_1,
    Gallery2023_2,
    Gallery2023_3,
    Gallery2023_4,
    Gallery2023_CoverImage,
    Gallery2024_CoverImage,
    Gallery2025_CoverImage,
    Gallery_HowDifferent_1,
    Gallery_HowDifferent_2,
    WhatWeDoBgImg,
    TakeWaysForChildren,
    HeroBgImage ,
    BalloonImage,
    TakeWaysForChildrenWithContent,
    WhatWeDoImageWithConent

}
